import * as e from "react";
function a({
  title: r,
  titleId: t,
  ...o
}, n) {
  return /* @__PURE__ */ e.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": t
  }, o), r ? /* @__PURE__ */ e.createElement("title", {
    id: t
  }, r) : null, /* @__PURE__ */ e.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  }), /* @__PURE__ */ e.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 9.563C9 9.252 9.252 9 9.563 9h4.874c.311 0 .563.252.563.563v4.874c0 .311-.252.563-.563.563H9.564A.562.562 0 0 1 9 14.437V9.564Z"
  }));
}
const i = /* @__PURE__ */ e.forwardRef(a);
export {
  i as default
};
//# sourceMappingURL=index.es29.js.map
